import styled from 'styled-components';

export const NotifText = styled.p`
  font-size: 18px;
  text-shadow: 0 1px 1px #000;
`;
